import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import moment from 'moment';
import * as selectors from '../../selectors';
import styles from './DailyGlucoseProfile.pcss';
const Weeks = ({ isInProgress })=>{
    const dailyRecordsPaginatedByMonth = useSelector(selectors.dailyRecordsPaginatedByMonth);
    if (!dailyRecordsPaginatedByMonth || !dailyRecordsPaginatedByMonth.length) {
        return null;
    }
    const startMoment = moment.utc(dailyRecordsPaginatedByMonth[0].date);
    const startWeekday = startMoment.day() - 1;
    const monthName = startMoment.format('MMM');
    let daysBeforeMonth = [];
    if (startWeekday > 0) {
        daysBeforeMonth = new Array(startWeekday).fill({});
    } else if (startWeekday === -1) {
        daysBeforeMonth = new Array(6).fill({});
    }
    const allDays = [
        ...daysBeforeMonth,
        ...dailyRecordsPaginatedByMonth
    ];
    const weeksIdx = [
        ...Array(Math.ceil(allDays.length / 7)).keys()
    ];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: weeksIdx.map((idx)=>{
            const week = {
                start: idx ? allDays[idx * 7].day : dailyRecordsPaginatedByMonth[0].day,
                end: allDays[idx * 7 + 6] ? allDays[idx * 7 + 6].day : allDays[allDays.length - 1].day
            };
            return /*#__PURE__*/ _jsx("div", {
                className: cn(styles.days, {
                    fadingLoader: isInProgress
                }),
                children: `${monthName} ${week.start}-${week.end}`
            }, `week-${week.start}-${week.end}`);
        })
    });
};
export default /*#__PURE__*/ memo(Weeks);
